window.addEventListener('DOMContentLoaded', () => {
	const swipers = document.querySelectorAll('.swiper-tabs-slider');

	swipers.forEach((swiper) => {
		const data = swiper.querySelector(`.swiper-data-handler`);

		console.log(data);
		
		const sectionId = data.dataset.section;
		const swipeEffect = data.dataset.effect;
		const pagination = (data.dataset.pagination);
		const bullets = data.dataset.bullets;
		const buttons = (data.dataset.buttons);
		const autoplay = (data.dataset.autoplay);
		const disableOnInteraction = (data.dataset.disable);
		const colsDesktop = Number(data.dataset.colDesktop);
		let colsMobile = Number(data.dataset.colMobile);
		const colsTablet = Number(data.dataset.colTablet);
		const delay = Number(data.dataset.delay)*1000;
		const speed = Number(data.dataset.speed);
		const paginationType = data.dataset.paginationType;
		const positionArrows = swiper.dataset.positionArrows;
		
		const paginationObj = {
			el: '.swiper-pagination',
			clickable: true,
			type: paginationType
		};

		let mySwiperNext; 
		let mySwiperPrev;
		
		console.log(positionArrows)

		if(positionArrows && positionArrows === 'external'){
			mySwiperNext = swiper.parentElement.querySelector(`.swiper-button-next[data-target]`);
			mySwiperPrev = swiper.parentElement.querySelector(`.swiper-button-prev[data-target]`);
		} else if(positionArrows && positionArrows === 'custom'){
			mySwiperNext = swiper.parentElement.querySelector(`.c-arrow-r`);
			mySwiperPrev = swiper.parentElement.querySelector(`.c-arrow-l`);
		} else {
			mySwiperNext = swiper.querySelector(`.swiper-button-next[data-target]`);
			mySwiperPrev = swiper.querySelector(`.swiper-button-prev[data-target]`);
		}
	
		const navigationObj = {
			nextEl: mySwiperNext,
			prevEl: mySwiperPrev,
		};

		let disableOn = false
		if (disableOnInteraction === 'true') disableOn = true

		const autoplayObj = {
			delay: delay,
			disableOnInteraction: disableOn,
			pauseOnMouseEnter: true,
		};
	
		const swiperObj = {
			slidesPerView: colsMobile,
			spaceBetween: 10,
			speed: speed,
      		watchSlidesProgress: true,
			loop: true,
			keyboard: {
				enabled: true,
			},
			breakpoints: {
				768: {
					slidesPerView: colsTablet,
					spaceBetween: 10,
				},
				1180: {
					slidesPerView: colsDesktop,
					spaceBetween: 10,
				},
				1440: {
					slidesPerView: colsDesktop,
					spaceBetween: 10,
				},
			},
		}
	
		if (pagination === 'true') {
			swiperObj.pagination = paginationObj;
		}
	
		if (buttons === 'true') {
			swiperObj.navigation = navigationObj;
		}

		if (autoplay === 'true') {
			swiperObj.autoplay = autoplayObj;
		}

		let swiperInstance = new Swiper(swiper, swiperObj);
	});
});
